import React from 'react';

const Support = () => (
  <section className="page">
    <h1>Support</h1>
    <p>
      Need help with Hestia Ledger? Whether it’s the free version or the full deal, I’ve got your back. 
      This app’s my baby, and I want it to work for you.
    </p>
    <p>
      Shoot me an email at <a href="mailto:bell@hestialedger.com">bell@hestialedger.com</a>. Tell me 
      what’s up—bugs, questions, whatever—and I’ll sort it out when I’m not knee-deep in code.
    </p>
    <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
  </section>
);

export default Support;